export { default } from './TextUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/TextUGCEditor/index.js